export const chunkBy = <T>(items: readonly T[], size: number): T[][] => {
  if (size <= 0) throw new Error(`chunkBy: size must be positive, got ${size}`);
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};
